import type { PropsWithChildren } from 'react';
import { StyleSheetManager } from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  ShadowEmbedRoot,
  useFontsLoader
} from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import type { ButtonSettings } from './types';
import { Widget } from './widget/widget';

export function Button(_settings: ButtonSettings) {
  return (
    <ButtonProviders>
      <Widget />
    </ButtonProviders>
  );
}

function ButtonProviders({ children }: PropsWithChildren) {
  const {
    customCSS,
    customJS,
    editMode,
    font,
    renderThumbnailMode,
    widgetId,
    _shadowDOMDisabled
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    'button',
    widgetId
  );
  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);
  useFontsLoader([font]);

  return (
    <StyleSheetManager
      shouldForwardProp={(propName) => !propName.startsWith('_')}
    >
      <PortalNestProvider>
        <Show when={_shadowDOMDisabled === true}>
          <CustomCSS
            customCSS={customCSS}
            prefixClassName={customCSSPrefixClassName}
          />

          <EmbedRoot customCSSClassName={customCSSPrefixClassName}>
            {children}
          </EmbedRoot>
        </Show>

        <Show when={!_shadowDOMDisabled}>
          <ShadowEmbedRoot
            width="auto"
            fullWidth
            font={font}
            customCSS={customCSS}
          >
            {children}
          </ShadowEmbedRoot>
        </Show>
      </PortalNestProvider>
    </StyleSheetManager>
  );
}
